import './games.css'
import { useNavigate } from 'react-router-dom'
import { Share2, ArrowRight } from 'lucide-react'
import { gameByKey } from './gameMeta'
import { useNextGame } from './GameFrame'

// ── ScoreCard — the result block the dailies share ───────────────────────────
// Eyebrow, headline, the number, tiles, then whatever the game wants to say,
// then one action row: Share, Next up (when a daily is still unplayed), and the
// admin replay. The boards above it stay each game's own.
export function ScoreHero({ game, day, headline, score, denom, sub, tiles, tilesLabel, practice = false, eyebrow }) {
  const g = gameByKey(game)
  return (
    <div style={{ textAlign: 'center' }}>
      {practice && <div className="gm-eyebrow" style={{ display: 'inline-block', color: 'var(--amber)', background: 'color-mix(in srgb, var(--amber) 12%, transparent)', borderRadius: 'var(--radius-pill)', padding: '4px 10px', marginBottom: 10 }}>🛠 Admin practice · not saved</div>}
      <div className="gm-eyebrow" style={{ color: g.tone }}>{eyebrow ?? `${g.label}${day != null ? ` · No. ${day}` : ''}`}</div>
      <div style={{ fontFamily: 'var(--font-serif)', fontSize: 22, fontWeight: 600, color: 'var(--text-strong)', margin: '6px 0 4px', textWrap: 'balance' }}>{headline}</div>
      <div className="gm-score" style={{ fontSize: 64, color: g.tone, margin: '6px 0 2px' }}>{score}{denom && <span style={{ fontSize: 22, color: 'var(--text-dim)', marginLeft: 3, letterSpacing: 0 }}>{denom}</span>}</div>
      {sub && <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)' }}>{sub}</div>}
      {tiles && <div style={{ display: 'flex', justifyContent: 'center', gap: 8, margin: '14px 0 4px' }} aria-label={tilesLabel}>{tiles}</div>}
    </div>
  )
}

export function ResultActions({ game, day, onShare, practice = false, isAdmin, onReplay, footer }) {
  const navigate = useNavigate()
  const g = gameByKey(game)
  const nextGame = useNextGame(game, day)
  const next = practice ? null : nextGame
  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ display: 'flex', gap: 10 }}>
        <button type="button" className="gm-pill" onClick={onShare} style={{ flex: 1, whiteSpace: 'nowrap' }}><Share2 size={16} /> Share</button>
        {next && <button type="button" className="gm-pill primary" onClick={() => navigate(next.route)} style={{ flex: 1.3, '--gm-tone': next.tone, whiteSpace: 'nowrap' }} aria-label={`Next up: ${next.label}`}><next.Icon size={17} strokeWidth={2.4} /> {next.label} <ArrowRight size={16} /></button>}
      </div>
      {isAdmin && (
        <button type="button" onClick={onReplay} style={{ width: '100%', marginTop: 10, background: 'none', border: `1px dashed color-mix(in srgb, ${g.tone} 40%, transparent)`, borderRadius: 12, color: g.tone, fontSize: 12, fontWeight: 700, padding: '9px 0', cursor: 'pointer', fontFamily: 'var(--font)' }}>🛠 Replay to test (admin, won’t save)</button>
      )}
      {footer && <div style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--text-dim)', marginTop: 14, lineHeight: 1.5 }}>{footer}</div>}
    </div>
  )
}

// The one-line door used where a game keeps its own action row (Cliffhanger's dossier).
export function NextGameDoor({ game, day, style }) {
  const navigate = useNavigate()
  const next = useNextGame(game, day)
  if (!next) return null
  return <button type="button" className="gm-pill primary" onClick={() => navigate(next.route)} style={{ '--gm-tone': next.tone, whiteSpace: 'nowrap', ...style }} aria-label={`Next up: ${next.label}`}><next.Icon size={17} strokeWidth={2.4} /> Next up: {next.label} <ArrowRight size={16} /></button>
}
